export default "__VITE_ASSET__CV1f6rPw__"